import { shallowRef } from 'vue';
import store from '@/store';
import { apiRequest } from '@/api/http';

// School years shared by the header's year picker and the School Year page,
// so editing a year refreshes the picker without reloading the whole app.
const years = shallowRef([]);

function select(id) {
  store.commit('setFilterSelected', id);
  const year = years.value.find((y) => y.id === id);
  if (year) store.commit('setSyType', year.syType);
}

// Picks the active year (status 1), or the first one. With keepSelection
// (after editing years) the current choice stays if it still exists.
async function load({ keepSelection = false } = {}) {
  const rows = await apiRequest('get', '/enroll-student/getSchoolYear');
  years.value = Array.isArray(rows) ? rows : [];
  if (!years.value.length) return years.value;
  const current = store.state.filterSelected;
  const keep = keepSelection && years.value.some((y) => y.id === current);
  const active = years.value.find((y) => y.status === 1);
  select(keep ? current : (active ?? years.value[0]).id);
  return years.value;
}

export function useSchoolYears() {
  return { years, load, select };
}
